export default __webpack_public_path__ + "static/media/careteam_my_tickets_instruction.0c4f5f47.svg";